import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI, DateTimeRange } from '@nexelem/graphne-api';

export const GRAPHNE_RESOURCE_SOFT_ASSIGNMENT_TASK_ID_KEY = 'graphne-resources-soft-assignment-task-id';

type Params = {
  taskId: string;
  myGroupId?: number;
  onlyAvailable?: boolean;
  name?: string;
  dateTimeRange?: DateTimeRange;
};

export const useGraphneResourcesSoftAssignmentTaskId = (
  { taskId, onlyAvailable = false, myGroupId, name, dateTimeRange }: Params,
  enabled?: boolean,
) => {
  const api = useGraphneAPI();

  return useQuery({
    enabled,
    queryKey: [GRAPHNE_RESOURCE_SOFT_ASSIGNMENT_TASK_ID_KEY, taskId, onlyAvailable, myGroupId, name],
    queryFn: () =>
      api.postGraphneResourcesSoftAssignmentTaskid({
        taskId,
        softResourcesAssignmentFilter: {
          onlyAvailable,
          myGroup: myGroupId,
          name,
          dateTimeRange,
        },
      }),
  });
};
